/**
 * Data export format values
 */
export enum DataExportFormatEnum {
	JSON = 'json',
	CSV = 'csv',
	XLSX = 'xlsx',
}
